module.exports = __webpack_public_path__ + "static/media/transfair-interreg-fwv.20e47dfb.png";